module.exports = __webpack_public_path__ + "img/icon_transportation_smte.2960afb7.svg";